import { render, staticRenderFns } from "./IconSvgQuestion.vue?vue&type=template&id=e2458d0e&scoped=true&"
import script from "./IconSvgQuestion.vue?vue&type=script&lang=js&"
export * from "./IconSvgQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2458d0e",
  null
  
)

export default component.exports